import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  news: [],
  loading: false,
  error: null,
  totalPages: 0,
  page: 1,
  detail: null,
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    fetchNewsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNewsSuccess: (state, action) => {
      state.news = action.payload.news;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.currentPage;
      state.loading = false;
    },
    fetchNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    detailNewsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    detailNewsSuccess: (state, action) => {
      state.detail = action.payload;
      state.loading = false;
    },
    detailNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addNewsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    addNewsSuccess: (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.news.push(action.payload);
      }
    },
    addNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateNewsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateNewsSuccess: (state, action) => {
      state.loading = false;
      const updatedNews = action.payload;
      if (updatedNews?.id) {
        const index = state.news.findIndex((item) => item.id === updatedNews.id);
        if (index >= 0) {
          state.news[index] = updatedNews;
        }
      }
    },
    updateNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteNewsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteNewsSuccess: (state, action) => {
      state.loading = false;
      state.news = state.news.filter((item) => item.id !== action.payload);
    },
    deleteNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchNewsRequest,
  fetchNewsSuccess,
  fetchNewsFailure,
  detailNewsRequest,
  detailNewsSuccess,
  detailNewsFailure,
  addNewsRequest,
  addNewsSuccess,
  addNewsFailure,
  updateNewsRequest,
  updateNewsSuccess,
  updateNewsFailure,
  deleteNewsRequest,
  deleteNewsSuccess,
  deleteNewsFailure,
} = newsSlice.actions;

export default newsSlice.reducer;
